module.exports = __webpack_public_path__ + "static/media/689.cb247742.webp";